import _http_v2 from "@packs/http_requests/_http_v2"
import store from "../../store/store"

export default function Lightning(opts={}){
    BaseConstructor.call(this)
    let {container, map} = opts
    let elements = {}
    let context = this
    let markers = []
    let CANVAS_LAYER

    this.generate = async() =>{
      
      if(!CANVAS_LAYER){
        CANVAS_LAYER = new L.MarkersCanvas().addTo(map)
      }
      if(markers.length > 0){
        context.remove()
      }
      
      let lightnings = await this.getLightnings()

      lightnings.forEach(lightning =>{

          let html = `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <polygon style="fill:teal;stroke:blue;stroke-width:4px;" fill-opacity="0.7" points="50,0 10,65 40,60,35,100 80,40 50,50"/>
          </svg>`
          
          const dataURI = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(html)}`;

          var icon = L.icon({
              iconUrl: dataURI,
              iconSize: [14, 14],
              iconAnchor: [7, 7]
          });

          let marker = L.marker([lightning.latitude, lightning.longitude], {icon: icon})
          .on({
            mouseover(e) {
              store.landslideConfigStore.setOption('tooltipOptions', {show:true, content: moment(lightning.datetime).add(3, 'hours').fromNow()})
              // console.log(lightning);
            },
            mouseout(e) {
              store.landslideConfigStore.setOption('tooltipOptions', {show:false, content: ''})
            },
          });
          markers.push(marker)
          
      })

      CANVAS_LAYER.addMarkers(markers);

      setTimeout(_=>{
        CANVAS_LAYER.redraw()
        map.invalidateSize()
      }, 1)
      
        
    }

    this.remove = () =>{
      if(CANVAS_LAYER){
        CANVAS_LAYER.removeMarkers(markers);
      }
      
      markers = []
    }

    this.update = () =>{

    }

    this.getLightnings = async () =>{
        return _http_v2.request('lightnings/last_lightnings')
    }
    
    init()
    
    function init(){
      store.lightningConfigStore.subscribe('SET_OPTION', data=>{
        if(data.option === 'active'){
          if(data.value){
            context.generate()
          } else {
            context.remove()
          }
        }
      })
    }
}

Lightning.prototype = Object.create(BaseConstructor.prototype)